export var Industries = [
    {
        label: 'Seleccionar',
        value: ''
    },
    {
        label: 'Agro',
        value: 'Agro'
    },
    {
        label: 'Autos, Motos y Náutica',
        value: 'Autos, Motos y Nautica'
    },
    {
        label: 'Belleza y Cuidado personal',
        value: 'Belleza y Cuidado personal'
    },
    {
        label: 'Clubes, Gimnasios y Soc. Fomento',
        value: 'Clubes, Gimnasios y Soc. Fomento'
    },
    {
        label: 'Consorcios',
        value: 'Consorcios'
    },
    {
        label: 'Educación',
        value: 'Educacion'
    },
    {
        label: 'Electro',
        value: 'Electro'
    },
    {
        label: 'Entretenimiento',
        value: 'Entretenimiento'
    },
    {
        label: 'Finanzas',
        value: 'Finanzas'
    },
    {
        label: 'Gastronomía',
        value: 'Gastronomia'
    },
    {
        label: 'Industria',
        value: 'Industria'
    },
    {
        label: 'Moda',
        value: 'Moda'
    },
    {
        label: 'Retail',
        value: 'Retail'
    },
    {
        label: 'Salud',
        value: 'Salud'
    },
    {
        label: 'Servicios',
        value: 'Servicios'
    },
    {
        label: 'Supermercados',
        value: 'Supermercados'
    },
    {
        label: 'Tecnología',
        value: 'Tecnologia'
    },
    {
        label: 'Turismo y Transporte',
        value: 'Turismo y Transporte'
    }
];
